var _ = require('underscore');
var TorsoCollection = require('backbone-torso/modules/Collection');
var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var urls = require('./../urls');

/**
 * Collection of surveyLanguageModels.
 *
 * @class surveyLanguageCollection
 * @constructor
 */
module.exports = new (TorsoCollection.extend({
  model: TorsoNestedModel,
  url: urls.languageServiceImpl,
  fetchHttpAction: 'POST',

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    TorsoCollection.prototype.initialize.apply(this, arguments);
    /**
     * Memoized version of fetch that will fetch the first time it is called and every call will return the same promise for that
     * first fetch.  Note that changing the options object passed in to fetchedOnce will cause a new fetch with that configuration.
     *
     * @method fetchOnce
     * @return {$.Deferred} the result of calling fetch, will reuse the same fetch promise every time fetchOnce is called.
     */
    this.fetchOnce = _.memoize(this.fetch);
  }
}))();
